import { createFileRoute } from '@tanstack/react-router';

import { OutstandingAndOverdue } from '~pages/payments/outstanding-and-overdue';

export const Route = createFileRoute(
  '/_auth/_layout/payment/outstanding-and-overdue',
)({
  component: OutstandingAndOverdue,
});
